import { ExternalLink } from 'lucide-react';
import { LinkButton } from '../ui/button';
import { Card, CardContent, CardFooter } from '../ui/card';

interface BlogPostProps {
  post: {
    id: string;
    title: string;
    date: string;
    content: string;
    image?: string;
    link?: string;
    partner?: string;
  };
}

export function BlogPost({ post }: BlogPostProps) {
  return (
    <Card
      role="button"
      onClick={() => {
        if (post.link) {
          window.open(post.link, '_blank');
        }
      }}
      className="cursor-pointer hover:border-gray-700 transition-colors shadow-xl"
    >
      {post.image && (
        <div className="w-full aspect-[16/9] overflow-hidden rounded-t-lg bg-gray-800">
          <img
            src={post.image}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>
      )}
      <CardContent>
        <div className="mb-4 pt-4">
          <h2 className="text-xl font-bold text-white">
            {post.title}
            {post.partner && <div className="badge badge-secondary">{post.partner}</div>}
          </h2>
          <p className="text-sm text-gray-400">{new Date(post.date).toLocaleDateString()}</p>
        </div>
        <p className="text-gray-300">{post.content}</p>
      </CardContent>
      <CardFooter>
        {post.link && (
          <LinkButton
            href={post.link}
            target="_blank"
            rel="noopener noreferrer"
            className="w-full bg-gradient-to-r from-blue-600 to-purple-600"
          >
            Read More
            <ExternalLink />
          </LinkButton>
        )}
      </CardFooter>
    </Card>
  );
}
